import { z } from "zod";

export const invitationSchema = z.object({
  email: z.string().email("Invalid email format"),
  role: z.enum(["admin", "member"], {
    message: "Role must be admin or member",
  }),
});

export type InvitationFormData = z.infer<typeof invitationSchema>;

const urlPattern = /^https?:\/\/.+/;

export const createBackendTokenSchema = z.object({
  name: z.string().min(1, "Name is required").max(255, "Name too long"),
  description: z.string().max(1000, "Description too long").optional(),
  token_type: z.literal("backend"),
  expires_at: z.string().optional(),
});

export const createFrontendTokenSchema = z.object({
  name: z.string().min(1, "Name is required").max(255, "Name too long"),
  description: z.string().max(1000, "Description too long").optional(),
  token_type: z.literal("frontend"),
  allowed_origins: z
    .array(z.string().regex(urlPattern, "Invalid URL format"))
    .min(1, "At least one origin is required"),
  expires_at: z.string().optional(),
});

export const createCliTokenSchema = z.object({
  name: z.string().min(1, "Name is required").max(255, "Name too long"),
  description: z.string().max(1000, "Description too long").optional(),
  token_type: z.literal("cli"),
  expires_at: z.string().optional(),
});

export const createTokenSchema = z.discriminatedUnion("token_type", [
  createBackendTokenSchema,
  createFrontendTokenSchema,
  createCliTokenSchema,
]);

export type CreateBackendTokenFormData = z.infer<
  typeof createBackendTokenSchema
>;
export type CreateFrontendTokenFormData = z.infer<
  typeof createFrontendTokenSchema
>;
export type CreateCliTokenFormData = z.infer<typeof createCliTokenSchema>;
export type CreateTokenFormData = z.infer<typeof createTokenSchema>;
